module.exports = __webpack_public_path__ + "static/img/Fassadengestaltung.501bece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/Fassadengestaltung.jpg
// module id = Mbsr
// module chunks = 1